import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import medium from "../../../../static/assets/images/Medium.png";
import success from "../../../../static/assets/images/Success.png";
import { getAgentPhoneNumber, getHeastiaCallBodyData, getaAgenthref } from "util/agentdetailsUtil";
import dynamic from "next/dynamic";
import { getVideoUrl } from "util/stringUtil";
const TeamSection = dynamic(() => import("../TeamSection/TeamSection"), {
  ssr: false,
});
const ListingsSection = dynamic(() => import("../ListingsSection/ListingsSection"), {
  ssr: false,
});
const ListingsSectionSSR = dynamic(() => import("../ListingsSection/ListingsSection"), {
  ssr: true,
});
const ReviewsRatingSection = dynamic(() => import("../ReviewsRatingSection/ReviewsRatingSection"), {
  ssr: false,
});
const RecommendationsSection = dynamic(
  () => import("../RecommendationsSection/RecommendationsSection"),
  {
    ssr: false,
  },
);
const FooterSection = dynamic(() => import("../FooterSection/FooterSection"), {
  ssr: false,
});
const SocialPostsSection = dynamic(() => import("../SocialPostsSection/SocialPostsSection"), {
  ssr: false,
});
const EmbVideo = dynamic(() => import("../../../shared/molecules/EmbVideo/EmbVideo"), {
  ssr: false,
});
const ReviewToast = dynamic(() => import("../ReviewsRatingSection/ReviewToast/ReviewToast"), {
  ssr: false,
});
import { canShowSocialMedia } from "util/agentdetailsUtil";

export default class ProfileDetailSection extends Component {
  state = {
    close: false,
    recommendclose: false,
    shareClose: false,
    reviewClose: false,
    showReviewResponse: true,
  };
  componentDidMount() {
    localStorage.setItem("listingPage", 1);
    localStorage.setItem("teamWtihListings", false);
    localStorage.setItem("defaultZoomLevel", 0);
    const { agentdetail, hestiaInformation, isGoogleBot } = this.props;
    if (!isGoogleBot) {
      if (agentdetail) {
        const { advertiserIdHestia, agents, type } =
          getHeastiaCallBodyData(agentdetail, true) || {};
        if (advertiserIdHestia && advertiserIdHestia.length > 0) {
          hestiaInformation(advertiserIdHestia, agents, 1, type, "agentdetail");
        }
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.askaQuestionSuccess == null && this.props.askaQuestionSuccess === "Success")
      this.setState({ close: true });
    if (prevProps.recommendationSuccess == null && this.props.recommendationSuccess === "Success") {
      this.setState({ recommendclose: true });
    }
    if (prevProps.reviewSuccess == null && this.props.reviewSuccess === "Success") {
      this.setState({ reviewClose: true });
    }
    if (prevProps.shareStatus == null && this.props.shareStatus === "Success") {
      this.setState({ shareClose: true });
    }
    if (this.state.reviewClose === true) {
      setTimeout(() => {
        this.props && this.props.setReviewSuccess(null);
        this.setState({ reviewClose: false });
      }, 5000);
    }
    if (this.state.recommendclose === true) {
      setTimeout(() => {
        this.props && this.props.setRecommendationSuccess(null);
        this.setState({ recommendclose: false });
      }, 5000);
    }
    if (this.state.close === true) {
      setTimeout(() => {
        this.props && this.props.setAskAQuestionSuccess(null);
        this.setState({ close: false });
      }, 5000);
    }
    if (this.state.shareClose === true) {
      setTimeout(() => {
        this.props && this.props.shareProfileSuccess(null);
        this.setState({ shareClose: false });
      }, 5000);
    }
  }
  showRecommendationModal = (m) => {
    if (this.props.showRecommendationModal) {
      this.props.showRecommendationModal(m);
    }
  };
  showReviewModal = (agentdetail) => {
    const { agent_bio } = agentdetail;
    if (this.props.showReviewModal) {
      this.props.showReviewModal(agent_bio);
    }
  };
  ask_a_question_modal = (m) => {
    if (this.props.ask_a_question_modal) {
      this.props.ask_a_question_modal(m);
    }
  };
  toasterhide = () => {
    // const ele = document.getElementById("ask-success-wrapper");
    // ele.classList.add("hide");
    if (this.state.recommendclose === true) {
      this.props && this.props.setRecommendationSuccess(null);
      this.setState({ recommendclose: false });
    }
    if (this.state.close === true) {
      this.props && this.props.setAskAQuestionSuccess(null);
      this.setState({ close: false });
    }
    if (this.state.shareClose === true) {
      this.props && this.props.shareProfileSuccess(null);
      this.setState({ shareClose: false });
    }
    if (this.state.reviewClose === true) {
      this.props && this.props.setReviewSuccess(null);
      this.setState({ reviewClose: false });
    }
  };
  getListingCounts = (hestiaData) => {
    let listingCounts = {
      forSaleCount: 0,
      forRentCount: 0,
      forSoldCount: 0,
      openHousesCount: 0,
      totalListings: 0,
    };
    listingCounts.forSaleCount = hestiaData.forSale ? hestiaData.forSale.total : 0;
    listingCounts.forRentCount = hestiaData.forRent ? hestiaData.forRent.total : 0;
    listingCounts.forSoldCount = hestiaData.forSold ? hestiaData.forSold.total : 0;
    listingCounts.openHousesCount = hestiaData.openHouses ? hestiaData.openHouses.total : 0;
    listingCounts.totalListings =
      listingCounts.forSaleCount +
      listingCounts.forRentCount +
      listingCounts.forSoldCount +
      listingCounts.openHousesCount;
    return listingCounts;
  };

  modifiedReviewData = (reviewData, imgurl, personName) => {
    const reviewDataModified =
      reviewData &&
      reviewData.map((m) => {
        if (m.reply) {
          m.reply.personName = personName;
          m.reply.imgurl = imgurl;
        }
        return m;
      });
    return reviewDataModified;
  };
  setShowReviewResponse = () => {
    this.setState({ showReviewResponse: false });
  };
  render() {
    const {
      agentdetail,
      recommendationData,
      reviewData,
      hestiaData,
      hestiaInformation,
      socialUpdateData,
      fetchCheckinsData,
      lang,
      langCode,
      profileData,
      reviewRatingResponse,
      query,
      clickDetectorData,
      socialUpdatesOnClick,
      socialloading,
      isUserLoggedIn,
      loginData,
      isGoogleBot,
    } = this.props;
    const { settings } = agentdetail?.agent_bio;
    // const backgroundPhoto = background_photo && agentdetail.agent_bio.background_photo.href;
    let showRating = false;
    if (settings && settings.display_ratings) {
      showRating = true;
    }
    const agentRating =
      showRating && agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.agent_rating
        ? agentdetail.agent_bio.agent_rating
        : null;
    const reviewCount =
      showRating && agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.review_count
        ? agentdetail.agent_bio.review_count
        : null;
    const recommandationCount =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.recommendations_count;
    const isDotRealtor =
      query && query.isDotRealtor && JSON.parse(query.isDotRealtor) ? true : false;
    // const imgurl =
    //   agentdetail &&
    //   agentdetail.agent_bio &&
    //   agentdetail.agent_bio.photo &&
    //   agentdetail.agent_bio.photo.href;
    const advertiser_id =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.advertiser_id;
    //const profileUrl = insertInImgUrl(imgurl, "d-r7_w144", 4);
    const profileUrl = agentdetail.agent_bio && getaAgenthref("agent", agentdetail.agent_bio, "");
    const personName = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.person_name;
    const reviewDataModified = showRating
      ? this.modifiedReviewData(reviewData, profileUrl, personName)
      : null;
    let listingCounts = {
      forSaleCount: 0,
      forRentCount: 0,
      forSoldCount: 0,
      openHousesCount: 0,
      totalListings: 0,
    };
    let showListings = false;
    listingCounts = hestiaData && this.getListingCounts(hestiaData);
    if (
      hestiaData &&
      settings &&
      (settings.display_listings || settings.display_sold_listings) &&
      ((listingCounts && listingCounts.totalListings > 0) || agentdetail.team)
    ) {
      showListings = true;
    }
    const video = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.video;
    const videoURl = video && getVideoUrl(video);
    const canShowSocialMediaSecion = profileData && canShowSocialMedia(profileData);
    const officenumber = agentdetail && getAgentPhoneNumber(agentdetail);
    return (
      <>
        <style jsx>{style}</style>
        {advertiser_id ? (
          <div className="main-review">
            <div className="main-review-sub padding-left_padding-right" id="main-review-sub">
              {!this.props.isProfileIncomplete && (
                <div>
                  {videoURl && <hr className="section-divider" />}
                  <div className="video-content">
                    {videoURl ? <EmbVideo videoUrl={videoURl} lang={lang} /> : null}
                  </div>
                  {agentdetail && agentdetail.team ? (
                    <TeamSection
                      agentdetail={agentdetail}
                      lang={lang}
                      isDotRealtor={isDotRealtor}></TeamSection>
                  ) : null}
                  {showListings ? (
                    isGoogleBot ? (
                      <ListingsSectionSSR
                        test={"ssr"}
                        hestiaData={hestiaData}
                        agentdetail={agentdetail}
                        hestiaInformation={hestiaInformation}
                        listingCounts={listingCounts}
                        query={query}
                        lang={lang}></ListingsSectionSSR>
                    ) : (
                      <ListingsSection
                        test={"csr"}
                        hestiaData={hestiaData}
                        agentdetail={agentdetail}
                        hestiaInformation={hestiaInformation}
                        listingCounts={listingCounts}
                        query={query}
                        lang={lang}></ListingsSection>
                    )
                  ) : null}

                  <ReviewsRatingSection
                    agentData={agentdetail}
                    query={query}
                    reviewData={reviewDataModified}
                    agentRating={agentRating}
                    reviewCount={reviewCount}
                    personName={personName}
                    showReviewModal={() => this.showReviewModal(agentdetail)}
                    reviewRatingResponse={reviewRatingResponse}
                    lang={lang}
                    isUserLoggedIn={isUserLoggedIn}
                    loginData={loginData}
                    clickDetectorData={clickDetectorData}></ReviewsRatingSection>

                  <RecommendationsSection
                    recommandationCount={recommandationCount}
                    recommendationData={recommendationData}
                    showRecommendationModal={() => this.showRecommendationModal(this.props)}
                    lang={lang}
                    clickDetectorData={clickDetectorData}></RecommendationsSection>

                  {canShowSocialMediaSecion ? (
                    <SocialPostsSection
                      socialUpdatesOnClick={socialUpdatesOnClick}
                      socialloading={socialloading}
                      socialUpdateData={socialUpdateData}
                      fetchCheckinsData={fetchCheckinsData}
                      lang={lang}
                      query={query}
                      langCode={langCode}></SocialPostsSection>
                  ) : null}
                  {socialloading ? null : <hr className="section-divider" />}
                </div>
              )}
              {this.props.isProfileIncomplete && <hr className="contact-section-divider" />}
            </div>
            <FooterSection
              {...this.props}
              ask_a_question_modal={() => this.ask_a_question_modal(this.props)}
              monetization_modal={this.props.monetization_modal}
              isMonetizationProfile={this.props.isMonetizationProfile}
              lang={lang}
              showRecommendationModal={() => this.showRecommendationModal(this.props)}
              agentContactNumber={officenumber}></FooterSection>
            {this.state.close ? (
              <div className="toaster-section" id="ask-success-wrapper">
                <div className="toast-msg">
                  <img alt="success" src={success} />{" "}
                  <span className="toast-text">
                    {lang && lang.ldp_content && lang.ldp_content.email_sent}
                  </span>
                </div>
                <span className="toaster-close" onClick={this.toasterhide}>
                  <img alt="toaster" src={medium} />
                </span>
              </div>
            ) : null}
            {this.state.recommendclose ? (
              <div className="toaster-section" id="ask-success-wrapper">
                <div className="toast-msg">
                  <img alt="success" src={success} />{" "}
                  <span className="toast-text">
                    {lang && lang.ldp_content && lang.ldp_content.recommendation_success_message}
                  </span>
                </div>
                <span className="toaster-close" onClick={this.toasterhide}>
                  <img alt="toaster" src={medium} />
                </span>
              </div>
            ) : null}
            {this.state.reviewClose ? (
              <ReviewToast
                reviewRatingResponse={reviewRatingResponse}
                setShowReviewResponse={this.toasterhide}
              />
            ) : null}
            {this.state.shareClose ? (
              <div className="toaster-section" id="ask-success-wrapper">
                <div className="toast-msg">
                  <img alt="success" src={success} />{" "}
                  <span className="toast-text">
                    {lang && lang.ldp_content && lang.ldp_content.email_success_message}
                  </span>
                </div>
                <span className="toaster-close" onClick={this.toasterhide}>
                  <img alt="toaster" src={medium} />
                </span>
              </div>
            ) : null}
          </div>
        ) : null}
      </>
    );
  }
}
ProfileDetailSection.defaultProps = {};

ProfileDetailSection.propTypes = {
  agentdetail: PropTypes.object,
  reviewData: PropTypes.array,
  socialUpdateData: PropTypes.array,
  fetchCheckinsData: PropTypes.array,
  recommendationData: PropTypes.array,
  ask_a_question_modal: PropTypes.func,
  hestiaData: PropTypes.object,
  hestiaInformation: PropTypes.func,
  showRecommendationModal: PropTypes.func,
  showReviewModal: PropTypes.func,
  setRecommendationSuccess: PropTypes.func,
  setAskAQuestionSuccess: PropTypes.func,
  shareProfileSuccess: PropTypes.func,
  askaQuestionSuccess: PropTypes.string,
  recommendationSuccess: PropTypes.string,
  setReviewSuccess: PropTypes.func,
  reviewSuccess: PropTypes.string,
  shareStatus: PropTypes.string,
  lang: PropTypes.object,
  langCode: PropTypes.string,
  profileData: PropTypes.object,
  reviewRatingResponse: PropTypes.object,
  query: PropTypes.object,
  clickDetectorData: PropTypes.object,
  socialUpdatesOnClick: PropTypes.func,
  socialloading: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  loginData: PropTypes.object,
  isGoogleBot: PropTypes.bool,
  isMonetizationProfile: PropTypes.bool,
  monetization_modal: PropTypes.func,
  isProfileIncomplete: PropTypes.bool,
};
